module.exports = __webpack_public_path__ + "media/Components/fonts/Abel-e8b810b8f2364e791205d6f12c5be3bf.ttf";